import { ReviewStatus, ProjectStatus } from './types';

// Default user for demo (will be replaced by actual auth)
export const MOCK_USER = {
  id: 'u-123',
  tpid: 'tpid-123',
  name: 'Alex Chen',
  email: 'alex.chen@tpcn.com',
  role: 'user' as const,
  is_active: true,
  created_at: new Date().toISOString(),
  last_login_at: new Date().toISOString(),
};

// Navigation steps
export const STEPS = [
  { id: 1, label: '上传', path: '/upload' },
  { id: 2, label: 'AI 分析', path: '/split' },
  { id: 3, label: '豁免', path: '/exemptions' },
  { id: 4, label: '审查', path: '/review' },
  { id: 5, label: '报告', path: '/report' },
  { id: 6, label: '导出', path: '/export' }
];

// API polling intervals (ms)
export const POLLING_INTERVALS = {
  SPLIT_STATUS: 2000,
  REVIEW_STATUS: 3000,
  EXPORT_STATUS: 2000,
};

// File size limits
export const FILE_LIMITS = {
  MAX_SIZE_MB: 50,
  ALLOWED_EXTENSIONS: ['.pdf', '.docx', '.doc'],
  ALLOWED_MIME_TYPES: [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
  ],
};

// Status colors for UI
export const STATUS_COLORS = {
  [ReviewStatus.COMPLIANT]: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
  },
  [ReviewStatus.NON_COMPLIANT]: {
    bg: 'bg-rose-50',
    text: 'text-rose-700',
    border: 'border-rose-200',
  },
  [ReviewStatus.UNCERTAIN]: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
  },
  [ReviewStatus.IGNORED]: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    border: 'border-slate-200',
  },
  [ReviewStatus.EXEMPTED]: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
  },
  [ReviewStatus.PENDING]: {
    bg: 'bg-slate-50',
    text: 'text-slate-400',
    border: 'border-slate-100',
  },
};

// Project status that allows certain actions
export const PROJECT_STATUS_ACTIONS = {
  canUpload: [ProjectStatus.CREATED, ProjectStatus.FILES_UPLOADED],
  canSplit: [ProjectStatus.FILES_UPLOADED, ProjectStatus.PARSED],
  canReview: [ProjectStatus.PARSED, ProjectStatus.REVIEWED],
  canGenerateReport: [ProjectStatus.REVIEWED, ProjectStatus.COMPLETED],
  canExport: [ProjectStatus.REVIEWED, ProjectStatus.COMPLETED],
};

// Disclaimer text
export const DISCLAIMER = {
  zh: '⚠️ 免责声明：本系统由AI辅助生成审核结果，所有建议仅供参考。最终决策请务必经过专业法务人员复核确认。AI生成的内容可能存在错误或遗漏，使用者需自行承担相关风险。',
  en: '⚠️ Disclaimer: This system generates review results with AI assistance. All suggestions are for reference only. Final decisions must be reviewed and confirmed by professional legal personnel. AI-generated content may contain errors or omissions, and users assume all related risks.',
};
